import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import TodayPanchang from "../component/todayPanchag";
import { recentOrder, tendersOrder, todayMarketSentiment } from "../utils/constants";

const Footer = () => {
  let location = useLocation();
  const [showPanchang, setShowPanchang] = useState(false);
  const togglePanchang = () => {
    setShowPanchang((prev) => !prev);
  };

  return (
    <>
      <div className="footer_wrap">
        <ul>
          <li>
            <Link to="/" className={location.pathname === "/" ? "active" : ""}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/rotation"
              className={location.pathname === "/rotation" ? "active" : ""}
            >
              Rotation
            </Link>
          </li>
          <li>
            <Link
              to="/delivery"
              className={location.pathname === "/delivery" ? "active" : ""}
            >
              Delivery
            </Link>
          </li>
          
          {/* <li><Link to="/todaynse">Today NSE</Link></li> */}
          {/* <li><Link to="/oi">Increase OI</Link></li> */}
          {/* <li>
            <Link
              to="/spikes"
              className={location.pathname === "/spikes" ? "active" : ""}
            >
              Spikes
            </Link>
          </li> */}
          
          {/* <li>
            <Link
              to="/sm"
              className={location.pathname === "/sm" ? "active" : ""}
            >
              SM
            </Link>
          </li> */}
          {/* <li>
            <Link
              to="/trends-setup"
              className={location.pathname === "/trends-setup" ? "active" : ""}
            >
              Setup
            </Link>
          </li> */}
          {/* <li>
            <Link
              to="/orders"
              className={location.pathname === "/orders" ? "active" : ""}
            >
              Orders
            </Link>
          </li> */}
          <li>
            <Link
              to="/bulk"
              className={location.pathname === "/bulk" ? "active" : ""}
            >
              Bulk
            </Link>
          </li>
          {/* <li>
            <Link
              to="/nr7-breakout"
              className={location.pathname === "/nr7-breakout" ? "active" : ""}
            >
              NR7 Breakout
            </Link>
          </li> */}
          <li>
            <Link
              to="/golden-crossover"
              className={
                location.pathname === "/golden-crossover" ? "active" : ""
              }
            >
              Golden Crossover
            </Link>
          </li>
          {/* <li>
            <Link
              to="/golden-stocks"
              className={location.pathname === "/golden-stocks" ? "active" : ""}
            >
              Golden Stocks
            </Link>
          </li> */}
          {/* <li><Link to="/pre-market">Pre Market</Link></li> */}
          
          
                    {/* <li>
            <Link
              to="/new-order"
              className={location.pathname === "/new-order" ? "active" : ""}
            >
              New Order
            </Link>
          </li> */}
          <li>
            <Link
              to="/delivery-heatmap"
              className={
                location.pathname === "/delivery-heatmap" ? "active" : ""
              }
            >
              HeatMap
            </Link>
          </li>
          <li>
            <Link
              to="/symbols"
              className={location.pathname === "/symbols" ? "active" : ""}
            >
              Symbols
            </Link>
          </li>
          {/* <li>
            <Link
              to="/hot-stars"
              className={location.pathname === "/hot-stars" ? "active" : ""}
            >
              Hot Stars
            </Link>
          </li> */}
          <li>
            <Link
              to="/watchlist"
              className={location.pathname === "/watchlist" ? "active" : ""}
            >
              WatchList
            </Link>
          </li>
          <li>
            <Link
              to="/pf"
              className={location.pathname === "/pf" ? "active" : ""}
            >
              My PF
            </Link>
          </li>
          {/* <li><Link to="/transit" className={location.pathname==='/today-market'?'active':''} >Transit</Link></li> */}
          <li>
            <a
              href="https://www.moneycontrol.com/markets/global-indices/"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              Global Market
            </a>
          </li>
          <li>
            <a
              href="https://www.livehindustan.com/business/share-market/news"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              News
            </a>
          </li>
          <li>
              <a 
                  title="Upcoming Tenders"
                  className="newsicon1"
                  href={`https://www.nseindia.com/companies-listing/corporate-filings-application`}
                  target="_blank"
                  rel="noopener noreferrer"
              >CA</a>
          </li>

          <li>
          <a 
                title="Today Sentiment"
                href={`https://www.google.com/ai?q=${todayMarketSentiment()}`}
                target="_blank"
                rel="noopener noreferrer"
            >T Sentiment</a>
          </li>

          {/* <li>
              <a 
                  title="Upcoming Tenders"
                  className="newsicon1"
                  href={`https://www.google.com/ai?q=${recentOrder()}`}
                  target="_blank"
                  rel="noopener noreferrer"
              >Recent Order</a>
          </li> */}

          {/* <li>
              <a 
                  title="Upcoming Tenders"
                  className="newsicon1"
                  href={`https://www.google.com/ai?q=${tendersOrder()}`}
                  target="_blank"
                  rel="noopener noreferrer"
              >Upcoming Tenders</a>
          </li> */}

          

          <li className="transit">
            <a onClick={togglePanchang} href="#"></a>
          </li>

          
        </ul>
      </div>

      <TodayPanchang
        show={showPanchang}
        onHide={() => setShowPanchang(false)}
      />
    </>
  );
};
export default Footer;
